import {
  Component,
  OnInit,
  ViewChild,
  inject,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddUserComponent } from 'src/app/users/components/add-user/add-user.component';
import { AddDebtorCreditorComponent } from 'src/app/debtor-creditor/add-debtor-creditor/add-debtor-creditor.component';
import { TransactionUpdateComponent } from 'src/app/transactions/transaction-update/transaction-update.component';
import { OpenTradeComponent } from 'src/app/trade/open-trade/open-trade.component';
import { EtrInvoiceUploadComponent } from 'src/app/trade/etr-invoice-upload/etr-invoice-upload.component';
import { CashReconcilationComponent } from 'src/app/transactions/cash-reconcilation/cash-reconcilation.component';
import { SubmitAccountsComponent } from 'src/app/transactions/submit-accounts/submit-accountscomponent';

@Component({
  selector: 'app-ngbd-modal-content',
  standalone: true,
  template: `
    <div class="modal-header" role="dialog" aria-modal="true">
      <h4 class="modal-title">Hi there!</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <app-uploads></app-uploads>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark"
        (click)="activeModal.close('Close click')"
      >
        Close
      </button>
    </div>
  `,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NgbdModalContentComponent {
  activeModal = inject(NgbActiveModal);
  @Input() name: string | undefined;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './sidebar.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SidebarComponent implements OnInit {
  @ViewChild('projctModal') projctModal: any;
  showMenu = '';
  showSubMenu = '';
  isClassAdded = false;
  public sidebarnavItems: RouteInfo[] = [];
  popupTitles: string[] = [
    'Add New User',
    'Reconcile Account',
    'New Credit Note',
    'New Credebtor',
    'Enter Transaction',
    'Open c-ETR Trade',
    'New Trade',
    'Submit Accounts',
  ];

  constructor(
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit() {
    this.sidebarnavItems = ROUTES.filter((sidebarnavItem) => sidebarnavItem);
  }

  addExpandClass(element: string, _expandclass: string) {
    this.removeSideBarClass(_expandclass);
    if (element === this.showMenu) {
      this.showMenu = '0';
      this.showSubMenu = '0';
    } else {
      this.showMenu = element;
      this.showSubMenu = '0';
    }
  }

  addExpandSubClass(element: string, _expandclass: string) {
    this.removeSideBarClass(_expandclass);
    this.callModal(element, _expandclass);
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  openModal() {
    this.projctModal.show();
  }

  callModal(title: string, _expandclass: string) {
    this.removeSideBarClass(_expandclass);
    switch (title) {
      case 'Add New User':
        this.modalService.open(AddUserComponent, { backdrop: true });
        break;
      case 'New Credebtor':
        this.modalService.open(AddDebtorCreditorComponent, { backdrop: true });
        break;
      case 'Enter Transaction':
        this.modalService.open(TransactionUpdateComponent, { backdrop: true });
        break;
      case 'New Credit Note': {
        const modalRef = this.modalService.open(TransactionUpdateComponent, {
          backdrop: true,
        });
        modalRef.componentInstance.pageTitle = title;
        modalRef.componentInstance.transactionType = 'Credit Note';
        break;
      }
      case 'Open a-ETR Trade':
        this.openTradeModal('Open a Trade');
        break;
      case 'Open b-ETR Trade':
        this.openTradeModal('Open b-ETR Trade');
        break;
      case 'Open c-ETR Trade':
        this.openTradeModal('ETR Invoice Upload');
        break;
      case 'Open d-ETR Trade':
        this.openTradeModal('Open a Trade');
        break;
      case 'Open f-ETR Trade':
        this.openTradeModal('Open a Trade');
        break;
      case 'Open a Trade':
        this.openTradeModal('Open a Trade');
        break;
      case 'New Trade':
        this.openTradeModal('Open a Trade');
        break;
      case 'Upload Revolving d-ETR':
        this.openTradeModal('Revolving ETR Invoice Upload');
        break;
      case 'Upload Trades':
        this.openTradeModal('Upload Trades');
        break;
      case 'Reconcile Account':
        this.modalService.open(CashReconcilationComponent, { backdrop: true });
        break;
      case 'Submit Accounts':
        this.modalService.open(SubmitAccountsComponent, {
          backdrop: 'static',
          keyboard: false,
        });
        break;
    }
  }

  openTradeModal(title: string) {
    if (title == 'Revolving ETR Invoice Upload') {
      const modalRef = this.modalService.open(EtrInvoiceUploadComponent, {
        backdrop: true,
      });
      modalRef.componentInstance.pageTitle = title;
    } else if (title == 'Upload Trades') {
      const modalRef = this.modalService.open(EtrInvoiceUploadComponent, {
        backdrop: true,
      });
      modalRef.componentInstance.pageTitle = title;
    } else {
      const modalRef = this.modalService.open(OpenTradeComponent, {
        backdrop: true,
      });
      modalRef.componentInstance.pageTitle = title;
    }
  }

  removeSideBarClass(_expandclass: string) {
    if (_expandclass !== 'collapse') {
      const element = document.getElementById('main-wrapper') as Element;
      element.classList.remove('show-sidebar');
    }
  }

  shouldDisplayItem(sidebarnavItem: any): boolean {
    return (
      !sidebarnavItem.extralink &&
      this.popupTitles.includes(sidebarnavItem.title)
    );
  }
}
